<script setup lang="ts">
// useHead({
//   link: [
//     {
//       rel: 'preload',
//       as: 'video',
//       href: '/video/banner-benefits.mp4',
//       type: 'video/mp4',
//       fetchpriority: 'high',
//     },
//   ],
// });

// const modalStore = useModalsStore();

// function handleOnClick() {
//   modalStore.openModal('CTA');
// };
</script>

<template>
    <div class="w-full h-8 lg:h-16">
      <NuxtLink to="/products/cloud-pbx/" class="w-full h-full">
        <NuxtImg
          src="/img/new/banner/faragir-plan.gif"
          alt="مرکز تلفن ابری"
          class="w-full h-full object-cover"
          :preload="{ fetchPriority: 'high' }"
          fetchpriority="high"
          loading="eager"
        />
      <!-- <div class="cursor-pointer w-full h-full" @click="handleOnClick">
        <video
          class="w-full h-full object-cover pointer-events-none"
          autoplay
          muted
          loop
          playsinline
          preload="auto"
          disablepictureinpicture
          controlslist="nodownload noplaybackrate"
          translate="no"
          aria-hidden="true"
        >
          <source 
            src="/video/banner-benefits.mp4" 
            type="video/mp4" 
            class="w-full h-16" 
          />
        </video>
      </div> -->
      </NuxtLink>
    </div>
</template>